module.exports = __webpack_public_path__ + "media/vid2.6d517bd0.mp4";